module.exports = __webpack_public_path__ + "static/media/german-language-course-in-delhi.4fe565a8.jpg";